import { render, staticRenderFns } from "./BgLayerSwitcher.vue?vue&type=template&id=64805904&"
import script from "./BgLayerSwitcher.vue?vue&type=script&lang=js&"
export * from "./BgLayerSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports